import {
    CHANGE_CERT_STATUS,
    EDIT_CERT_USER,
    DELETE_CERT_USER,
    SET_CERT_USER,
    SET_CONTRIBUTOR,
    CHANGE_PRE_MEMBERSHIP,
    ADD_CERT_USER,
    CERT_COURSE_UNENROLL,
  } from "../constants";
  
  export const deleteCertUserById = (payload) => ({
    type: DELETE_CERT_USER,
    payload: payload,
  });
  
  export const changeCertStatus = (payload) => ({
    type: CHANGE_CERT_STATUS,
    payload: payload,
  });
  
  export const changePreMemberShip = (payload) => ({
    type: CHANGE_PRE_MEMBERSHIP,
    payload: payload,
  });
  
  export const setCertUser = (payload) => ({
    type: SET_CERT_USER,
    payload: payload,
  });
  
  export const setContributor = (payload) => ({
    type: SET_CONTRIBUTOR,
    payload: payload,
  });
  
  export const addCertUser = (payload) => ({
    type: ADD_CERT_USER,
    payload: payload,
  });
  
  export const editCertUser = (payload) => ({
    type: EDIT_CERT_USER,
    payload: payload,
  });
  
  export const certCourseUnenroll = (payload) => ({
    type: CERT_COURSE_UNENROLL,
    payload: payload,
  });
  